import { rest } from 'msw';
export var mockExtractPassportInfoResponse = function mockExtractPassportInfoResponse() {
  return rest.post("/api/rpj-bff/v1/ocr/passport_info_extraction", function (req, res, ctx) {
    return res(ctx.json({
      name: 'Tester',
      surname: 'McTest',
      birth_date: '01/01/2021',
      country: 'CAN',
      sex: 'M',
      nationality: 'CAN',
      document_number: 'P0123456',
      expiry_date: '01/01/2025',
      place_of_birth: 'CAN',
      mrz: {},
      metadata: {}
    }));
  });
};